import { FC } from 'react';

//components
import { CustomList as List } from '../custom-list';

//styles
import styles from './csr-dropdown-menu.module.scss';
import { CMSData } from '@/types/cmsData';

export interface ICsrDropdownMenuProps {
  offers?: CMSData;
  pcOptProg?: CMSData;
  aboutShoppers?: CMSData;
  customerService?: CMSData;
  inStore?: CMSData;
}

const CsrDropdownMenu: FC<ICsrDropdownMenuProps> = ({ offers, pcOptProg, aboutShoppers, customerService, inStore }) => (
  <div className={styles.csrDropDownContainer} data-testid="shortcutLinks">
    <div className={styles.csrMultiLinks} data-testid="shortcutLinks1">
      <List linkCategory={offers} />
      <List linkCategory={pcOptProg} />
    </div>
    <div className={styles.csrLinks} data-testid="shortcutLinks2">
      <List linkCategory={aboutShoppers} />
    </div>
    <div className={styles.csrLinks} data-testid="shortcutLinks3">
      <List linkCategory={customerService} />
    </div>
    <div className={styles.csrLinks} data-testid="shortcutLinks4">
      <List linkCategory={inStore} />
    </div>
  </div>
);

CsrDropdownMenu.defaultProps = {
  offers: {
    __typename: '',
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
  pcOptProg: {
    __typename: '',
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
  aboutShoppers: {
    __typename: '',
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
  customerService: {
    __typename: '',
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
  inStore: {
    __typename: '',
    name: '',
    uid: '',
    link: '',
    hasChildren: false,
    child: [],
  },
};

export default CsrDropdownMenu;
